import { Injectable } from '@angular/core';
import { Idea, IdeaInputParams } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewIdeaService {
  constructor(
    private busService: BusService,
    private eventsService: EventsService,
  ) {}

  save(
    topic: Session,
    data: {
      inputParams: IdeaInputParams;
      script: string;
      shortTitle?: string;
      oneLiner?: string;
    } & Partial<Pick<Idea, 'outline' | 'evidence'>>,
  ) {
    this.busService.publish(
      this.eventsService.requested.action.session.idea.create,
      {
        title: data.shortTitle,
        one_liner: data.oneLiner,
        inputParams: data.inputParams,
        categories: [],
        outline: data.outline,
        textScript: { original: { value: data.script, v: 0 } },
        evidence: data.evidence,
        published: true,
      },
      topic,
    );
    return new Observable<Idea>(observer => {
      this.busService.subscribe(
        this.eventsService.received.action.session.idea.create.success,
        (idea: Idea) => (observer.next(idea), observer.complete()),
      );
    });
  }
}
